<div class="timebanner-top">
  <div class="timebanner-block" *ngIf="timebanner?.currentshow">
    <div class="table-header">Nu op antenne:</div>
    <div>{{ timebanner.currentshow.startClock}}-{{ timebanner.currentshow.endClock}}</div>
    <div><a href="{{timebanner.currentshow.linkURL}}"> {{ timebanner.currentshow.showName}}</a></div>
  </div>

  <div class="timebanner-block" *ngIf="timebanner?.upcomingshow">
    <div class="table-header">Straks:</div>
    <div>{{ timebanner.upcomingshow.startClock}}-{{ timebanner.upcomingshow.endClock}}</div>
    <div><a href="{{timebanner.upcomingshow.linkURL}}"> {{ timebanner.upcomingshow.showName}}</a></div>
  </div>
</div>